import React from "react";
import router from "src/router.tsx";
import store from "./store";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "src/components/ui/Toaster.tsx";
import { ThemeProvider } from "src/components/theme-provider.tsx";
import ErrorBoundary from "src/components/ErrorBoundary.tsx";
import { setupGlobalErrorHandlers } from "src/app/globalErrorHandler.ts";

import "./styles.css";

// Setup global error handlers for uncaught errors and unhandled promise rejections
setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light" storageKey="dharam-kaata-theme">
        <Provider store={store}>
          <RouterProvider router={router}>
            <Toaster />
          </RouterProvider>
        </Provider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
